import { render, staticRenderFns } from "./NaoxjStockStatisticsCategory.vue?vue&type=template&id=a193bb64&scoped=true&"
import script from "./NaoxjStockStatisticsCategory.vue?vue&type=script&lang=js&"
export * from "./NaoxjStockStatisticsCategory.vue?vue&type=script&lang=js&"
import style0 from "./NaoxjStockStatisticsCategory.vue?vue&type=style&index=0&lang=css&"
import style1 from "./NaoxjStockStatisticsCategory.vue?vue&type=style&index=1&id=a193bb64&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a193bb64",
  null
  
)

export default component.exports